module.exports = __webpack_public_path__ + "img/motor_no51.e042dafc.jpg";